<template>
    <div >
        <banner     v-model:is-open="isOpen"
                    :auto-hide="autoHide"
                    :bg-color="bgColor"
                    :fg-color="fgColor">

            <template #banner-container>
                <div :class="[vertical ? 'flex-col justify-between' : 'flex-col']"
                        class="flex text-left">
                    <div class="flex justify-start">
                        <div class="shrink-0">
                            <slot name="icon">
                                <!-- Heroicon name: exclamation -->
                                <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </slot>
                        </div>
                        <div class="ml-3">
                            <h3     :class="fgColor"
                                    class="text-sm text-left font-semibold my-0 py-1">
                                <slot name="title">(Default) Attention needed</slot>
                            </h3>
                        </div>
                    </div>

                    <div :class="fgColor">
                        <p class="md:mt-0 md:ml-6">
                            <a      @click="fathomGoalTrack"
                                    :href="link"
                                    :class="fgColor"
                                    class="flex flex-nowrap items-center whitespace-nowrap font-semibold">
                                <span class="">
                                    <slot name="action-text"></slot>
                                </span>
                                <span class="ml-2" aria-hidden="true">&rarr;</span>
                            </a>
                        </p>
                    </div>
                </div>
            </template>
        </banner>
    </div>
</template>

<script>
import Banner from "@/components/Banners/Banner"

export default {
    name: "BannerAction",
    mixins: [],
    components: { Banner },
    compatConfig: { ATTR_FALSE_VALUE: false },
    props: {
        link: {
            type: String,
            required: true,
        },
        goalText: {
            type: String,
            default: '',
        },
        bgColor: {
            type: String,
            default: 'bg-yellow-50',
        },
        fgColor: {
            type: String,
            default: 'text-yellow-700',
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        autoHide: {
            type: Number,
            default: 0,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        fathomGoalTrack() {
            if (window.fathomLoaded && this.goalText.length > 0) {
                window.fathom.trackGoal(this.goalText, 0);
            }
        }
    },
    watch: {

    },
    computed: {
    
    },
}
</script>